<template>
  <div>
    <div class="row">
      <div class="col-sm-2"></div>
      <div class="col-sm-10">
        <h2 style="font-weight: 600; margin-bottom: 0.5rem !important">Company official seal</h2>
        <small style="font-size: 80% !important">Company official seal for training certificates</small>
      </div>
    </div>
    <form ref="form" data-url="/admin/company/profile/edit-seal" class="mt-4" enctype="multipart/form-data">
      <div class="form-group row mb-0">
        <div class="col-sm-8">
          <app-input
            type="custom-file-upload"
            :label="$t('upload_your_file')"
            v-model="inputs.company_seal"
            :required="true"
          />
          <small class="text-muted font-italic">
            {{ $t("recommended_custom_file_validation") }}
          </small>
        </div>
      </div>
      <div class="mt-2" v-if="userRole.company_id == inputs.id">
        <app-load-more
          :preloader="preloader"
          :label="$t('save')"
          type="submit"
          class-name="btn btn-primary text-center"
          @submit="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";

export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        company_seal: this.$store.state.userCompanyProfile.dataProfile.company.official_seal,
        id: this.$store.state.userCompanyProfile.dataProfile.company.id,
      },
    };
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      const formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }

      this.save(formData);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
  },
};
</script>
